import './NavBurger.scss';


import logo from '../Logo_skinny.png';
import HomeIcon from '@mui/icons-material/Home';
import CloseIcon from '@mui/icons-material/Close';

// import {NavLink} from 'react-router-dom';
import { Link } from 'react-scroll';




const NavBurger = ({showNav, handleShowBurger}) => {
  return(
    <div className={`nav_burger ${showNav ? "nav_burger--show" : "nav_burger--hidden"}`}>

    <button 
      className='close_nav'
      onClick={handleShowBurger}
      >
      <CloseIcon className='cross'/>
    </button>

      <Link
          activeClass="active"
              to="banner"
              spy
              smooth
              offset={0}
              duration={500}
              onClick={handleShowBurger}
         >  
        <img src={logo} alt='logo' className='burger_nav_logo' />
         
      </Link> 
       <Link
       className='burger_link_home'
       activeClass="active"
              to="banner"
              spy
              smooth
              offset={0}
              duration={500}
              onClick={handleShowBurger}
       
       >  
        <HomeIcon/>Accueil
   
      </Link>
      <Link
         className='burger_link_presentation'
         activeClass="active"
              to="videoc"
              spy
              smooth
              offset={0}
              duration={500}
              onClick={handleShowBurger}
         
         >  
          Présentation
      </Link> 
      



      <Link
         className='burger_link_category'
         activeClass="active"
              to="navpictures"
              spy
              smooth
              offset={0}
              duration={500}
              onClick={handleShowBurger}
       
         >  
          Catégories
      </Link> 


   

      <Link
         className='burger_link_contact'
         activeClass="active"
              to="nav_bannPics os"
              spy
              smooth
              offset={0}
              duration={500}
              onClick={handleShowBurger}
         >  
          Contact
      </Link> 
    </div>
  )
}

export default NavBurger;